<template>
  <v-sheet>
    <v-radio-group v-model="groupBy" label="Group By:" row dense>
      <v-radio label="Semester" value="semester"></v-radio>
      <v-radio label="Program" value="program"></v-radio>
      <v-radio label="Client" value="client.fullName"></v-radio>
    </v-radio-group>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="assignments"
      :group-by="groupBy"
      :group-desc="groupBy == 'semester' ? true : false"
      sort-by="approvalStartDate"
      sort-desc
    >
      <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group">
            <v-icon v-if="isOpen">mdi-minus</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
          <span
            v-if="groupBy === 'client.fullName'"
            class="mx-5 text-decoration-underline indigo--text"
            style="cursor: pointer"
            @click="goToClient(item.clientId)"
            >{{ group }}</span
          >
          <span v-else class="mx-5 font-weight-bold" style="font-size: 14px">{{
            group
          }}</span>
        </td>
      </template>
      <template v-slot:[`item.client.fullName`]="{ item }">
        <span
          style="cursor: pointer"
          class="text-decoration-underline indigo--text"
          @click="goToClient(item.clientId)"
          >{{ item.client.fullName }}</span
        ></template
      >
      <template v-slot:[`item.mandate`]="{ item }">
        <span>{{ item.mandate }}</span
        ><v-chip
          :active="Boolean(item.isSubstitute)"
          x-small
          pill
          label
          color="accent"
          class="ma-2"
        >
          Sub
        </v-chip></template
      >
    </v-data-table>
  </v-sheet>
</template>

<script>
export default {
  props: ["providerId"],
  data() {
    return {
      assignments: [],
      loading: false,
      headers: [
        { text: "Client", value: "client.fullName" },
        { text: "Semester", value: "semester" },
        { text: "Approval Start Date", value: "formattedApprovalStartDate" },
        { text: "Approval End Date", value: "formattedApprovalEndDate" },
        { text: "Program", value: "program" },
        { text: "Service", value: "service" },
        { text: "Mandate", value: "mandate" },
        { text: "Start Date", value: "formattedStartDate" },
        { text: "End Date", value: "formattedEndDate" },
      ],
      groupBy: "semester",
    };
  },
  async mounted() {
    this.loading = true;
    this.assignments = await this.$store.dispatch(
      "plansModule/getAssignmentsForProvider",
      this.providerId
    );
    this.loading = false;
  },
  methods: {
    goToClient(clientId) {
      this.$router.push({
        name: "ClientDetails",
        params: { clientId: clientId },
      });
    },
  },
};
</script>
